import { pathJoin } from 'src/reducers/routing/utils'

export const createDetailRoutesMap = (prefix: string) => ({
  overview: pathJoin(prefix)('overview').chain,
  properties: pathJoin(prefix)('properties').chain,
  tickets: pathJoin(prefix)('tickets').chain,
})
